export enum ContractStatus {
    InElaboration = 1,
    NacaoDigitalSignature = 2,
    ConsultantSignature= 3,
    Completed = 4,
    Check = 5
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/ContractStatus.ts